import React from "react";
import { LegalLayout } from "./LegalLayout";

export default function CommunityGuidelines() {
  return (
    <LegalLayout
      slug="community-guidelines"
      title="Community Guidelines"
      lastUpdated="September 08, 2026"
      sections={[
        { heading: "Purpose", body: [
          `These Community Guidelines help keep AdGen Store (https://adgen.store) safe, respectful, and useful for everyone. By using the service, you agree to follow these rules in addition to our Terms of Service.`,
        ]},
        { heading: "Prohibited Content", body: [
          `Do not generate, upload, or share content that:\n- Is illegal under applicable law;\n- Sexualizes or exploits minors in any way;\n- Promotes terrorism or violent extremism;\n- Incites violence, hatred, or discrimination against individuals or groups;\n- Discloses non-public personal information of real individuals (doxxing);\n- Creates realistic likenesses of real people without their consent;\n- Constitutes deceptive political content or disinformation;\n- Presents fabricated medical or legal claims as professional advice;\n- Is fraudulent, phishing, or scam material.`,
          `[PLACEHOLDER — replace with reviewed legal text and align with your content-moderation system's actual enforcement capabilities.]`,
        ]},
        { heading: "Prohibited Behaviour", body: [
          `Do not harass, threaten, or impersonate other users, AdGen Store staff, or public figures.`,
          `Do not attempt to bypass safety systems or content filters, perform prompt-injection attacks against our AI providers, or reverse-engineer the service. [PLACEHOLDER — replace with reviewed legal text]`,
        ]},
        { heading: "Intellectual Property", body: [
          `Respect other people's copyrights, trademarks, and rights of publicity when creating prompts or uploading reference material.`,
          `[PLACEHOLDER — describe how references to copyrighted characters, brands, or licensed media are handled by your moderation stack, and link to the Copyright Complaint Policy.]`,
        ]},
        { heading: "Reporting Violations", body: [
          `If you encounter content or behaviour that violates these Guidelines, please report it by emailing adgenstore@gmail.com with relevant details (link, description, screenshots if applicable).`,
        ]},
        { heading: "Enforcement", body: [
          `Depending on the severity and history of the violation, we may take one or more of the following actions: issue a warning, remove the offending content, revoke associated credits, restrict specific features, suspend the account temporarily, or terminate it permanently. [PLACEHOLDER — replace with reviewed legal text]`,
          `[PLACEHOLDER — describe the appeals process and typical response times once finalized.]`,
        ]},
        { heading: "Changes", body: [
          `We may update these Guidelines as the service evolves and as new safety concerns emerge. Material changes will be communicated via email or an in-app notice.`,
        ]},
        { heading: "Contact", body: [
          `Name : AdGen Store Team\nAddress: Sunworld Arista, Sector-168, Noida, Uttar Pradesh, India\nEmail: adgenstore@gmail.com`,
        ]},
      ]}
    />
  );
}
